/* eslint-disable */
import fileService from '@/shared/file/file-service';
import logService from '@/shared/entity-logger';
import { db, firebase } from '@/shared/firebase/firebase-init';
import clubModel from './club-model';
import _ from 'underscore'

const KEY_TEAMS = 'teams'
const KEY_CLUBS= 'clubs'
const KEY_CLUB= 'club'
const NAME_ENTITY= 'club'
const KEY_USER_MANAGER = 'usersManager'

export default {
  list() {
    return new Promise((resolve) => {
      db.ref(KEY_CLUBS).once('value').then((snapshot) => { 
        var list = []
        snapshot.forEach(childSnapshot => {
           
          var modelToShow = {
            ...childSnapshot.val()
          }

          if (modelToShow.statusManager === "verified") {
            modelToShow.statusManagerEs = "Registrado"
          } else if (modelToShow.statusManager === "unverified") {
            modelToShow.statusManagerEs = "Sin invitación"
          } else if (modelToShow.statusManager === "invited") {
            modelToShow.statusManagerEs = "Invitado"
          }
          
          list.push(modelToShow)
        });
        
        resolve(list.reverse())
      });
    });
  },

  save(model, loggedUser) {
    if (model.id) {
      return this.update(model, loggedUser);
    }

    return this.create(model, loggedUser);
  },

  find(id) {
    return new Promise((resolve, reject) => {
      db.ref(KEY_CLUBS).child(id).once('value').then((snapshot) => { 
        var model = snapshot.val();
        
        if (!model) {
          return null;
        }
        
        if (model.logo.name === "") {
          resolve(model)
        } 
        
        fileService.fillDownloadURL(
          KEY_CLUBS,
          model.id,
          'logo',
          model.logo
        ).then(() => {
          resolve(model)
        }).catch((error) => {
          reject(error)
        });
      })
    });
  },

  /**
   * Elimina un club, solo en el caso de que el club no tenga equipos
   * @param {*} model 
   * @param {*} loggedUser 
   */
  destroy(model, loggedUser) {
    const modelToDestroy = {
      ...model,
      modified:  firebase.database.ServerValue.TIMESTAMP,
      deleted:  firebase.database.ServerValue.TIMESTAMP,
      deletedBy:  { id: loggedUser.id, email: loggedUser.email },
      modifiedBy:  { id: loggedUser.id, email: loggedUser.email }
    };

    return new Promise((resolve, reject) => {

      // 1. Comprobamos si el club tiene equipos 
      if (_.size(model.teams) > 0) {
        reject(new Error("El club tiene equipos asignados."))
        return
      } 
 
      var updates = {};
      updates['/' + KEY_CLUBS + '/' + model.id ] = null;

     
      // Si tiene manager, modificamos el club del manager
      if (model.manager) {
        updates['/' + KEY_USER_MANAGER + '/' +  model.manager.id + '/' + KEY_CLUBS + '/' + model.id ] = null
      }

      db.ref().update(updates, (error) => {
        if (error) {
          // The write failed...
          reject(error)
        } else {

          // Data deleted successfully!
          fileService.delete(KEY_CLUBS, model.id, 'logo', model.logo)
          .then(() => {
            logService.log(modelToDestroy, "deleted", KEY_CLUBS, NAME_ENTITY)
            resolve()
          }).catch((error) => {
            reject(error)
          });
        }
      })
      
    })
  },

  update(model, loggedUser) {
   
    const modelToUpdate = {
      ...model,
      modified:  firebase.database.ServerValue.TIMESTAMP,
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    };

    return new Promise((resolve, reject) => {
      fileService.uploadB64Img(KEY_CLUBS, modelToUpdate.id, 'logo', modelToUpdate.logo)
        .then(() => {
           
          var updates = {};
          updates['/' + KEY_CLUBS + '/' + modelToUpdate.id ] = clubModel.forUpdate(modelToUpdate);

          // Si el club tiene equipos, modificamos la información de cada uno de los equipos
          // TODO: modificar el club del manager
          
          // Si tiene equipos, modificamos los clubs de cada equipo
          if (model.teams) {
            _.each(model.teams, (value, key, obj) => {
              updates['/' + KEY_TEAMS + '/' + key + '/' + KEY_CLUB] = clubModel.forSimple(modelToUpdate)
            })
          }

          // Si tiene manager, modificamos el club del manager
          if (model.manager) {
            updates['/' + KEY_USER_MANAGER + '/' +  model.manager.id + '/' + KEY_CLUBS + '/' + modelToUpdate.id ] = clubModel.forManager(modelToUpdate)
          }

          db.ref().update(updates, (error) => {
            if (error) {
              // The write failed...
              reject(error)
            } else {
              // Logs
              logService.log(modelToUpdate, "modified", KEY_CLUBS, NAME_ENTITY)
              resolve()
            }
          })
        }).catch((error) => {
          reject(error)
        });
      });
  },

  create(model,loggedUser) {
    const modelToSave = {
      ...model,
      statusManager: "unverified",
      id: db.ref(KEY_CLUBS).push().key,
      created: firebase.database.ServerValue.TIMESTAMP,
      modified:  firebase.database.ServerValue.TIMESTAMP,
      createdBy: { id: loggedUser.id, email: loggedUser.email } ,
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    };

    return new Promise((resolve, reject) => {
      fileService.uploadB64Img(KEY_CLUBS, modelToSave.id, 'logo', modelToSave.logo)
      .then(() => {
        db.ref(KEY_CLUBS).child(modelToSave.id).set(clubModel.forCreate(modelToSave), (error) => {
          if (error) {
            // The write failed...
            reject(error)
          } else {
            // Data saved successfully!
            logService.log(modelToSave, "created", KEY_CLUBS, NAME_ENTITY)
            resolve(modelToSave)
          }
        });
      }).catch((error) => {
        reject(error)
      });
    });
  },

  listOptions() {
    return new Promise((resolve) => {
      db.ref(KEY_CLUBS).once('value').then((snapshot) => { 
        const list = []
        snapshot.forEach(childSnapshot => {
          var modelOption = {}
          modelOption.id = childSnapshot.key
          modelOption.name = childSnapshot.val().name
          modelOption.logo = childSnapshot.val().logo
          modelOption.teams = childSnapshot.val().teams
          modelOption.manager = childSnapshot.val().manager
          list.push(modelOption)
        });
        resolve(list)
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/entities/club/club-service.js